import React from "react";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { QRCodeSVG } from "qrcode.react";

/**
 * Builds the customer-app review URL the QR encodes. Wraps the invoice's existing review
 * shortlink; the UTM pair attributes scans to the tech app QR surface (NUB-376).
 */
export const buildReviewQrUrl = (shortcode: string): string =>
  `${process.env.REACT_APP_CUSTOMER_WEB_APP_URL}/reviews/${shortcode}?utm_source=techapp&utm_content=qrcode`;

/**
 * Customer-facing full-screen QR view. Headed by the same sticky app bar the invoice and job
 * pages use, so the back arrow returns the tech to whichever page opened it. The body below
 * stays deliberately bare — the tech hands the phone to the customer to scan.
 */
export const ReviewQrDialog: React.FC<{
  shortcode: string;
  open: boolean;
  onClose: () => void;
}> = ({ shortcode, open, onClose }) => {
  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <div className="flex flex-col min-h-screen">
        <AppBar position={"sticky"}>
          <Toolbar>
            <IconButton onClick={onClose} aria-label="back">
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h6">Review QR</Typography>
          </Toolbar>
        </AppBar>
        <Box
          className="flex-grow"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          bgcolor="#FFF"
          padding={3}
          textAlign="center"
        >
          <Typography variant="h5" gutterBottom>
            Scan to leave us a review
          </Typography>
          <Box marginY={3}>
            <QRCodeSVG value={buildReviewQrUrl(shortcode)} size={288} level="M" marginSize={2} />
          </Box>
          <Typography variant="body2" color="textSecondary">
            Point your phone&apos;s camera at the code
          </Typography>
        </Box>
      </div>
    </Dialog>
  );
};
